import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';

export default function FallbackUI({ resetError }) {
  return (
    <div
      className="
    flex
    items-center
    justify-center
    w-screen
    h-screen
   bg-gradient-to-r from-[#47C8D6] to-white-300
  "
    >
      <div className="px-40 py-20 bg-white rounded-md shadow-xl">
        <div className="flex flex-col items-center">
          <FontAwesomeIcon
            icon={faScrewdriverWrench}
            size="8x"
            className="text-blue-600"
          />

          <h6 className="mb-2 text-2xl font-bold text-center text-gray-800 md:text-3xl">
            <span className="text-red-500">Oops!</span> Something went wrong
          </h6>

          <p className="mb-8 text-center text-gray-500 md:text-lg">
            We are working on fixing the problem.
            <br />
            Please try again.
          </p>

          <Link
            to="/"
            className="px-6 py-2 text-sm font-semibold text-blue-800 bg-blue-100"
            onClick={resetError}
          >
            Go back home
          </Link>
        </div>
      </div>
    </div>
  );
}
